import React, { useEffect, useState } from "react";

const LOGO_SRC = "/Dprologo.png";

const BrandSplash = ({
  minDurationMs = 1200,
  message = "Cargando tu experiencia…",
  logoSrc = LOGO_SRC,
  onDone,
  variant = "deportivospro",
}) => {
  const [phase, setPhase] = useState("in");
  const [done, setDone] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = performance.now();
    let rafId;

    const tick = (now) => {
      const elapsed = now - start;
      const ratio = Math.min(1, elapsed / minDurationMs);
      setProgress(ratio * 100);
      if (ratio < 1) {
        rafId = requestAnimationFrame(tick);
      } else {
        setPhase("out");
        setTimeout(() => {
          setDone(true);
          if (typeof onDone === "function") onDone();
        }, 220);
      }
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [minDurationMs, onDone]);

  if (done) return null;

  const palette =
    variant === "sportconnect"
      ? {
          from: "from-emerald-500",
          via: "via-teal-500",
          to: "to-cyan-500",
          ring: "rgba(16, 185, 129, 0.35)",
          glow: "rgba(16, 185, 129, 0.45)",
          text: "text-emerald-300",
        }
      : {
          from: "from-red-600",
          via: "via-orange-500",
          to: "to-amber-400",
          ring: "rgba(239, 68, 68, 0.35)",
          glow: "rgba(249, 115, 22, 0.5)",
          text: "text-orange-300",
        };

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center overflow-hidden
                  bg-gradient-to-br from-[#0a0a0a] via-[#14080a] to-[#0a0a0a]
                  transition-opacity duration-300 ease-out
                  ${phase === "out" ? "opacity-0" : "opacity-100"}`}
      role="status"
      aria-live="polite"
      style={{
        WebkitUserSelect: "none",
        userSelect: "none",
        WebkitTouchCallout: "none",
      }}
    >
      <div
        className="absolute inset-0 opacity-70 pointer-events-none"
        style={{
          background: `radial-gradient(circle at 50% 45%, ${palette.glow} 0%, transparent 55%)`,
        }}
      />

      <div className="relative flex flex-col items-center">
        <div className="relative">
          <div
            className="absolute -inset-10 rounded-full blur-3xl animate-pulse"
            style={{ background: palette.glow }}
          />

          <div
            className="absolute -inset-3 rounded-full animate-spin"
            style={{
              border: "2px dashed transparent",
              borderTopColor: palette.ring,
              borderRightColor: palette.ring,
              animationDuration: "3s",
            }}
          />

          <div
            className={`absolute -inset-2 rounded-full bg-gradient-to-br ${palette.from} ${palette.via} ${palette.to} opacity-70 blur-md animate-pulse`}
          />

          <div className="relative w-28 h-28 rounded-full overflow-hidden ring-4 ring-white/10 shadow-2xl">
            <img
              src={logoSrc}
              alt="DeportivosPro"
              className="w-full h-full object-cover"
              draggable="false"
              onContextMenu={(e) => e.preventDefault()}
              onDragStart={(e) => e.preventDefault()}
            />
          </div>
        </div>

        <div className="mt-8 text-center px-6">
          <h1 className="text-2xl font-bold tracking-tight text-white drop-shadow">
            DeportivosPro
          </h1>
          <div
            className={`mt-2 text-xs uppercase tracking-[0.3em] font-medium ${palette.text}`}
          >
            {variant === "sportconnect" ? "SportConnect" : "Pronósticos Deportivos"}
          </div>
        </div>

        <div className="mt-10 w-56 h-1.5 rounded-full bg-white/10 overflow-hidden relative">
          <div
            className={`absolute top-0 left-0 h-full rounded-full bg-gradient-to-r ${palette.from} ${palette.via} ${palette.to} transition-[width] duration-150 ease-out`}
            style={{ width: `${progress}%` }}
          />
        </div>

        <div className="mt-4 flex items-center gap-2 text-white/80 text-sm">
          <span
            className={`inline-block w-2 h-2 rounded-full bg-gradient-to-br ${palette.from} ${palette.to} animate-pulse`}
          />
          <span className="font-medium">{message}</span>
        </div>
      </div>
    </div>
  );
};

export default BrandSplash;
